import React from "react";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";
import PropTypes from "prop-types";
import { Modal } from "../modal/Modal";
import { CancelButton } from "../input/Button";
import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  message: {
    fontSize: "16px",
    fontWeight: 600
  },
  reason: {
    marginTop: "var(--Space-100, 10px)",
    color: "var(--Gray-3, #828282)"
  }
});

export const AutoExitReason = {
  concurrentSession: "concurrentSession",
  idle: "idle"
};

const messages = defineMessages({
  [AutoExitReason.concurrentSession]: {
    id: "auto-exit-warning-modal.reason.concurrent-session",
    defaultMessage: "You have started another session."
  },
  [AutoExitReason.idle]: {
    id: "auto-exit-warning-modal.reason.idle",
    defaultMessage: "You have been idle for too long."
  }
});

export function AutoExitWarningModal({ onCancel, reason, secondsRemaining }) {
  const intl = useIntl();
  const styles = useStyles();

  return (
    <Modal
      title={<FormattedMessage id="auto-exit-warning-modal.title" defaultMessage="Warning" />}
      onClose={onCancel}
      actions={<CancelButton onClick={onCancel} />}
    >
      <p className={styles.message}>
        <FormattedMessage
          id="auto-exit-warning-modal.message"
          defaultMessage="Auto-ending session in {secondsRemaining} seconds"
          values={{ secondsRemaining: secondsRemaining }}
        />
      </p>
      <p className={styles.reason}>{intl.formatMessage(messages[reason])}</p>
    </Modal>
  );
}

AutoExitWarningModal.propTypes = {
  reason: PropTypes.string.isRequired,
  secondsRemaining: PropTypes.number.isRequired,
  onCancel: PropTypes.func
};
